import { render, staticRenderFns } from "./MySalesTable.vue?vue&type=template&id=b02b4566"
import script from "./MySalesTable.vue?vue&type=script&lang=js"
export * from "./MySalesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports